import { render, staticRenderFns } from "./LogDetail.vue?vue&type=template&id=0f062bc2&scoped=true&"
import script from "./LogDetail.vue?vue&type=script&lang=js&"
export * from "./LogDetail.vue?vue&type=script&lang=js&"
import style0 from "./LogDetail.vue?vue&type=style&index=0&id=0f062bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f062bc2",
  null
  
)

export default component.exports